import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import WeatherPanel from "@/components/WeatherPanel";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const mediaUrl = (u) => (u && u.startsWith("/api/")) ? BACKEND + u : u;

export default function WelcomeDisplay() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [slide, setSlide] = useState(0);
  const [now, setNow] = useState(new Date());
  const load = () => axios.get(`${BACKEND}/api/display/${token}`).then((r) => setD(r.data)).catch(() => setD({ mode: "neutral", signature: "Never Forget the Difference You Make", slideshow: [], logo: "/assets/asset3.png" }));
  useEffect(() => { load(); const p = setInterval(load, 60000); const c = setInterval(() => setNow(new Date()), 1000); return () => { clearInterval(p); clearInterval(c); }; /* eslint-disable-next-line */ }, [token]);
  useEffect(() => { const s = setInterval(() => setSlide((x) => x + 1), 6000); return () => clearInterval(s); }, []);
  if (!d) return <div className="min-h-screen bg-[#05070D]" />;
  const imgs = d.slideshow || [];
  const bg = imgs.length ? mediaUrl(imgs[slide % imgs.length]) : null;

  return (
    <div className="min-h-screen bg-[#05070D] text-[#FBF8F0] relative overflow-hidden" data-testid="welcome-display">
      {bg && <img src={bg} alt="" className="absolute inset-0 w-full h-full object-cover opacity-40 transition-opacity duration-1000" />}
      <div className="absolute inset-0" style={{ background: "radial-gradient(circle at 50% 40%, rgba(5,7,13,0.4), rgba(5,7,13,0.92))" }} />
      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center text-center px-8">
        <img src={d.logo || "/assets/asset3.png"} alt="The D" className="h-28 mb-8" />
        {d.mode === "welcome" ? (
          <>
            <p className="text-[#B7942E] tracking-[0.4em] uppercase text-sm mb-3">Welcome</p>
            {d.guest_first_name && <h1 className="font-serif text-6xl md:text-7xl mb-4">{d.guest_first_name}</h1>}
            {d.custom_message && <p className="text-xl text-white/80 max-w-2xl mb-6 italic">"{d.custom_message}"</p>}
            {(d.arrival || d.departure) && <p className="text-white/60 mb-6">{d.arrival} → {d.departure}</p>}
            {(d.atmosphere || d.lighting) && <p className="text-[#5AA6B8] mb-8">{[d.atmosphere, d.lighting].filter(Boolean).join(" · ")}</p>}
            {d.qr_codes?.length > 0 && (
              <div className="flex gap-8 mb-8" data-testid="display-qrs">
                {d.qr_codes.map((q) => (<div key={q.kind} className="text-center"><img src={q.png} alt={q.kind} className="h-24 w-24 rounded bg-white p-1" /><p className="text-xs text-white/60 mt-2 capitalize">{q.kind.replace("-", " ")}</p></div>))}
              </div>
            )}
          </>
        ) : (
          <>
            <h1 className="font-serif text-5xl md:text-6xl mb-4">The night looks different here.</h1>
            <p className="text-white/60 text-xl mb-2">{now.toLocaleDateString(undefined, { weekday: "long", month: "long", day: "numeric" })}</p>
            <p className="text-white/40 text-3xl font-serif mb-8">{now.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</p>
          </>
        )}
        <div className="mt-8"><WeatherPanel variant="display" /></div>
        <p className="text-[#B7942E] italic font-serif text-lg absolute bottom-10">{d.signature}</p>
      </div>
    </div>
  );
}
